import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import typography from "../../cssUtils/typography";
import { ColorsConstants } from "../../cssUtils/constants";
import ButtonOne from "../../common/normal-button";
import ButtonTwo from "../../common/dashboard-button";

const CreateCampaignModal = ({
  open,
  onClose,
  campaignName,
  campaignDescription,
  onNameChange,
  onDescriptionChange,
  nameError,
  nameCharCount,
  descCharCount,
  onSubmit,
  
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px", p: 1 },
      }}
    >
      <DialogTitle>
        <Typography sx={typography.h1}>
          Create WhatsApp Campaign
        </Typography>
        <Typography sx={{ ...typography.bodyLarge, mt: 1 }}>
          Enter campaign details to get started.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {/* Name */}
          <Typography sx={{ mb: 1 }}>
            Campaign Name *
          </Typography>

          <Box sx={{ position: "relative" }}>
            <TextField
              fullWidth
              value={campaignName}
              onChange={onNameChange}
              error={!!nameError}
              helperText={nameError}
              placeholder="Enter campaign name"
            />
            <Typography
              sx={{
                position: "absolute",
                right: 10,
                top: 12,
                fontSize: 12,
                color: "#9AA6B8",
              }}
            >
              {nameCharCount}/50
            </Typography>
          </Box>

          {/* Description */}
          <Typography sx={{ mt: 3, mb: 1 }}>
            Campaign Description
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={4}
            value={campaignDescription}
            onChange={onDescriptionChange}
          />

          <Typography sx={{ textAlign: "right", mt: 0.5, fontSize: 12 }}>
            {descCharCount}/250
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <ButtonTwo onClick={onClose} title="Cancel" />
        <ButtonOne
          title="Next"
          onClick={onSubmit}
          disabled={!campaignName.trim() || nameError}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CreateCampaignModal;